<template>
  <v-autocomplete
    v-model="country"
    :items="countries"
    item-title="name"
    item-value="value"
    label="País"
    required
    variant="outlined"
    bg-color="white"
    hide-details="auto"
    clearable
    @focus="$event.target.select()"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import countriesJson from '@/utils/countries.json'

interface Props {
  modelValue?: string
}

const { modelValue = '' } = defineProps<Props>()

const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

defineOptions({
  name: 'TCountrySelect',
})

const country = computed<string>({
  get(): string {
    return modelValue
  },
  set(value: string) {
    emit('update:modelValue', value)
  },
})

const ptNames = new Intl.DisplayNames([ 'pt-BR' ], {
  type: 'region',
})

const enNames = new Intl.DisplayNames([ 'en' ], {
  type: 'region',
})

interface Country {
  name: string
  value: string
}

const countries: Country[] = countriesJson
  .map(([ alpha2 ]) => {
    const name = ptNames.of(alpha2)
    const value = enNames.of(alpha2)

    if (!name || !value) {
      return null
    }

    return {
      name,
      value,
    }
  })
  .filter((country): country is Country => country !== null)
  .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'))

</script>
